(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationTakeMissedReasonDialogController', PatientMedicationTakeMissedReasonDialogController);

    PatientMedicationTakeMissedReasonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatientMedicationTakeMissedReason'];

    function PatientMedicationTakeMissedReasonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatientMedicationTakeMissedReason) {
        var vm = this;

        vm.patientMedicationTakeMissedReason = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.patientMedicationTakeMissedReason.id !== null) {
                PatientMedicationTakeMissedReason.update(vm.patientMedicationTakeMissedReason, onSaveSuccess, onSaveError);
            } else {
                PatientMedicationTakeMissedReason.save(vm.patientMedicationTakeMissedReason, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:patientMedicationTakeMissedReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
